if ($(".type-detail").length) {
  (function () {
    function copyUpsellBanner() {
      var $banner = $(".p-image-wrapper .up-banner-productDetail-bellow_product_photo");
      var $target = $(".p-info-wrapper");

      if (!$banner.length || !$target.length) {
        return;
      }

      if ($target.find(".up-banner-productDetail-bellow_product_photo").length) {
        return;
      }

      $target.append($banner.clone(true, true));
    }

    function runCopyUpsellBanner() {
      setTimeout(copyUpsellBanner, 50);
    }

    $(function () {
      runCopyUpsellBanner();

      document.addEventListener("UpsellProductRendered", runCopyUpsellBanner);
      document.addEventListener("UpsellProductChanged", runCopyUpsellBanner);
      document.addEventListener("UpsellBannersRendered", runCopyUpsellBanner);
    });
  })();
  $("html").on("click", '#p-detail-tabs a[data-toggle="scroll"][href^="#"]', function (e) {
    e.preventDefault();

    var targetSelector = $(this).attr("href");

    // fallback pro hvězdičky nahoře, které nemusí mít href
    if (!targetSelector || targetSelector === "#") {
      targetSelector = "#ratingTab";
    }

    var $target = $(targetSelector);

    if (!$target.length) {
      return;
    }

    var menuHeight = $("#header").outerHeight() || 0;
    var fixedCartHeight = $(".detailFixedCart:visible").outerHeight() || 0;
    var extraOffset = 110; // o kolik px výš chceš skončit
    var extraOffsetMobile = 10;
    var offset = 0;

    if ($("body").hasClass("mobile")) {
      offset = Math.max(menuHeight, 0) + extraOffsetMobile;
    } else {
      offset = Math.max(menuHeight - fixedCartHeight, 0) + extraOffset;
    }

    $("html, body").animate(
      {
        scrollTop: $target.offset().top - offset,
      },
      500,
    );
  });

  $("html").on("click", ".product-top .starsLabel--productDetail", function (e) {
    e.preventDefault();

    var $target = $("#ratingTab");

    if (!$target.length) {
      return;
    }

    var menuHeight = $("#header").outerHeight() || 0;
    var fixedCartHeight = $(".detailFixedCart").outerHeight() || 0;
    var offset = 0;

    if ($("body").hasClass("mobile")) {
      // mobil: header bez detailFixedCart + malá mezera
      offset = Math.max(menuHeight - fixedCartHeight, 0) + 10;
    } else {
      // desktop: header bez detailFixedCart

      offset = Math.max(menuHeight - fixedCartHeight, 0);
    }

    $("html, body").animate(
      {
        scrollTop: $target.offset().top - offset,
      },
      500,
    );
  });

  $(".starsLabel--productDetail span").each(function () {
    var $span = $(this);
    var text = $span.text().trim();
    var count = parseInt(text, 10);

    if (isNaN(count)) return;

    var word = translation("recenzi");

    if (count === 1) {
      word = translation("recenze");
    } else if (count >= 2 && count <= 4) {
      word = translation("recenze");
    }

    $span.text(count + " " + word);
  });

  if ($(".variant-list").length || $(".surcharge-list").length) {
    $(".p-info-wrapper .variant-list").last().after('<tr class="upsellCrossell"></tr>');
  } else {
    $(".p-info-wrapper .detail-parameters tr").first().before('<tr class="upsellCrossell"></tr>');
  }

  if ($("#productVideos").length) {
    initProductVideoGallery();
  }

  updateFreeShippingBox(".p-info-wrapper .detail-parameters");

  document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    updateFreeShippingBox(".p-info-wrapper .detail-parameters");
  });
  document.addEventListener("ShoptetCartUpdated", function () {
    updateFreeShippingBox(".p-info-wrapper .detail-parameters");
  });

  function infoWrapper() {
    // hodnocení produktu do p-info-wrapper
    if ($("#ratingsList").length) {
      var firstFiveStarClone = $("#ratingsList .vote-wrap")
        .filter(function () {
          return $(this).find(".star").length === 5 && $(this).find(".star.star-on").length === 5;
        })
        .first()
        .clone();

      if (firstFiveStarClone.length) {
        var $ratingBox = $('<div class="p-detail-rating"></div>');

        var rateAverageClone = $("#ratingWrapper .rate-average-inner").clone();
        $ratingBox.append(firstFiveStarClone);
        $ratingBox.prepend(rateAverageClone);
        $ratingBox.find(".vote-wrap").each(function () {
          var authorName = $(this).find('.vote-name span[itemprop="name"]').first();
          if (authorName.length) {
            $(this).find(".vote-content").append(authorName);
          }
        });
        $(".p-info-wrapper").prepend($ratingBox);
      }
    }

    // přesun prvků v p-info-wrapper
    $(".position--benefitProduct .benefitBanner__item .usp").prependTo(".p-info-wrapper");
    $(".p-detail > .p-detail-inner > .p-detail-inner-header").clone().prependTo(".p-info-wrapper");
    $(".availability-value").insertBefore(".delivery-time-label");

    const $addToCart = $(".add-to-cart");
    const $price = $(".p-final-price-wrapper");

    if ($addToCart.length && $price.length) {
      const $wrap = $('<div class="add-to-cart-wrap"></div>');
      $addToCart.wrap($wrap);
      $addToCart.parent(".add-to-cart-wrap").prepend($price);
    }

    // článek a ambasador přesun do p-info-wrapper
    var $infoWrapper = $(".p-info-wrapper");

    if ($(".p-detail-article").length) {
      $(".p-detail-article").appendTo($infoWrapper);
    }
    if ($(".p-detail-review").length) {
      $(".p-detail-review").appendTo($infoWrapper);
    }

    $(".p-info-wrapper").css("opacity", "1");
  }

  infoWrapper();
  initExtraBanners();

  if ($("body.mobile .p-thumbnails-wrapper .p-thumbnails-inner").length) {
    var touchStartX = 0;
    var touchEndX = 0;
    var minSwipeDistance = 50;
    var isImageSliding = false;

    var thumbTouchStartX = 0;
    var thumbStartLeft = 0;
    var thumbIsDragging = false;
    var thumbWasDragged = false;

    $(".p-image-wrapper .p-image").on("touchstart", function (e) {
      touchStartX = e.originalEvent.touches[0].clientX;
    });

    $(".p-image-wrapper .p-image").on("touchend", function (e) {
      touchEndX = e.originalEvent.changedTouches[0].clientX;

      var swipeDistance = touchEndX - touchStartX;

      if (Math.abs(swipeDistance) < minSwipeDistance) {
        return;
      }

      if (swipeDistance < 0) {
        changeImage(true); // swipe doleva = další
      } else {
        changeImage(false); // swipe doprava = předchozí
      }
    });

    $(".p-thumbnails-inner").on("touchstart", function (e) {
      var thumbnailsInner = $(this);

      thumbTouchStartX = e.originalEvent.touches[0].clientX;
      thumbStartLeft = parseInt(thumbnailsInner.css("left"), 10) || 0;
      thumbIsDragging = true;
      thumbWasDragged = false;

      thumbnailsInner.stop(true, true);
    });

    $(".p-thumbnails-inner").on("touchmove", function (e) {
      if (!thumbIsDragging) {
        return;
      }

      var thumbnailsWrapper = $(".p-thumbnails-wrapper");
      var thumbnailsInner = $(this);

      var wrapperWidth = thumbnailsWrapper.outerWidth();
      var innerWidth = thumbnailsInner.outerWidth();

      if (innerWidth <= wrapperWidth) {
        return;
      }

      var currentX = e.originalEvent.touches[0].clientX;
      var diffX = currentX - thumbTouchStartX;

      if (Math.abs(diffX) > 5) {
        thumbWasDragged = true;
      }

      var newLeft = thumbStartLeft + diffX;

      var maxLeft = 0;
      var minLeft = wrapperWidth - innerWidth;

      if (newLeft > maxLeft) {
        newLeft = maxLeft;
      }

      if (newLeft < minLeft) {
        newLeft = minLeft;
      }

      thumbnailsInner.css({
        position: "relative",
        left: newLeft,
      });

      e.preventDefault();
    });

    $(".p-thumbnails-inner").on("touchend touchcancel", function () {
      thumbIsDragging = false;

      setTimeout(function () {
        thumbWasDragged = false;
      }, 80);
    });

    $(".p-thumbnails-inner").on("click", "a", function (e) {
      if (thumbWasDragged) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    });

    function changeImage(isNext) {
      if (isImageSliding) {
        return;
      }

      var thumbnails = getGalleryThumbs();
      var highlightedThumbnail = $(".p-thumbnails-inner").find("a.highlighted");
      var totalThumbnails = thumbnails.length;
      var currentIndex = thumbnails.index(highlightedThumbnail);

      if (!totalThumbnails) {
        return;
      }

      thumbnails.removeClass("highlighted");

      if (highlightedThumbnail.length === 0 || currentIndex < 0) {
        highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
      } else {
        currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;

        highlightedThumbnail = thumbnails.eq(currentIndex);
      }

      highlightedThumbnail.addClass("highlighted");

      moveThumbnailsInner(highlightedThumbnail, isNext);

      setTimeout(function () {
        updateMainImageSlide(highlightedThumbnail, isNext);
      }, 10);
    }

    function moveThumbnailsInner(highlightedThumbnail, isNext) {
      if (thumbIsDragging) {
        return;
      }

      var thumbnailsWrapper = $(".p-thumbnails-wrapper");
      var thumbnailsInner = $(".p-thumbnails-inner");

      if (!thumbnailsWrapper.length || !thumbnailsInner.length || !highlightedThumbnail.length) {
        return;
      }

      var wrapperWidth = thumbnailsWrapper.outerWidth();
      var innerWidth = thumbnailsInner.outerWidth();

      if (innerWidth <= wrapperWidth) {
        thumbnailsInner.css("left", "0px");
        return;
      }

      var thumbPosition = highlightedThumbnail.position().left;
      var thumbWidth = highlightedThumbnail.outerWidth(true);

      var thumbCenter = thumbPosition + thumbWidth / 2;
      var targetLeft = wrapperWidth / 2 - thumbCenter;

      var minLeft = wrapperWidth - innerWidth;
      var maxLeft = 0;

      if (targetLeft > maxLeft) {
        targetLeft = maxLeft;
      }

      if (targetLeft < minLeft) {
        targetLeft = minLeft;
      }

      thumbnailsInner
        .stop(true, true)
        .css({
          position: "relative",
        })
        .animate(
          {
            left: targetLeft,
          },
          300,
        );
    }

    function updateMainImageSlide(highlightedThumbnail, isNext) {
      var isVideoThumb = highlightedThumbnail.hasClass("video-preview-thumb");
      var videoContainer = getMainImageContainer();

      if (isVideoThumb) {
        showVideoPreviewInMain(videoContainer);
        return;
      }

      clearVideoState(videoContainer);

      var findHighlighted = highlightedThumbnail.attr("href");
      var findHighlightedAlt = highlightedThumbnail.find("img").attr("alt") || "";
      var mainImageLink = $(".p-image a.p-main-image");
      var mainImage = mainImageLink.find("img");

      if (!findHighlighted || !mainImage.length) {
        return;
      }

      isImageSliding = true;

      var wrapper = mainImage.closest(".p-image");
      var directionOut = isNext ? "-100%" : "100%";
      var directionIn = isNext ? "100%" : "-100%";

      wrapper.css({
        position: "relative",
        overflow: "hidden",
      });

      mainImage.stop(true, true);

      var oldImage = mainImage.clone();

      oldImage.addClass("slide-old-image").css({
        position: "absolute",
        top: mainImage.position().top,
        left: mainImage.position().left,
        width: mainImage.outerWidth(),
        height: mainImage.outerHeight(),
        zIndex: 2,
        margin: 0,
        transition: "transform 0.3s ease",
      });

      mainImage
        .before(oldImage)
        .css({
          opacity: 0,
          transform: "translateX(" + directionIn + ")",
          transition: "transform 0.3s ease, opacity 0.3s ease",
        })
        .attr({
          src: findHighlighted,
          alt: findHighlightedAlt,
        });

      mainImageLink.attr("href", findHighlighted);

      setTimeout(function () {
        oldImage.css({
          transform: "translateX(" + directionOut + ")",
          opacity: 1,
        });

        mainImage.css({
          opacity: 1,
          transform: "translateX(0)",
        });
      }, 20);

      setTimeout(function () {
        oldImage.remove();

        mainImage.css({
          transform: "",
          opacity: "",
          transition: "",
        });

        isImageSliding = false;
      }, 350);
    }
  }

  if ($(".desktop .p-thumbnails-wrapper .p-thumbnails-inner").length) {
    $(".p-image-wrapper").addClass("haveThumbnails");
    $(".p-image-wrapper .p-image").append('<span class="arrow-prev"></span><span class="arrow-next"></span>');
    $("body").on("click", ".arrow-prev, .arrow-next", function () {
      var thumbnails = getGalleryThumbs();
      var highlightedThumbnail = $(".p-thumbnails-inner").find("a.highlighted");
      var isNext = $(this).hasClass("arrow-next");
      var totalThumbnails = thumbnails.length;
      var currentIndex = thumbnails.index(highlightedThumbnail);
      thumbnails.removeClass("highlighted");
      if (highlightedThumbnail.length === 0) {
        highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
      } else {
        currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;

        highlightedThumbnail = thumbnails.eq(currentIndex);
      }
      highlightedThumbnail.addClass("highlighted");
      setTimeout(function () {
        updateMainImage(highlightedThumbnail);
      }, 10);
    });
    function updateMainImage(highlightedThumbnail) {
      var isVideoThumb = highlightedThumbnail.hasClass("video-preview-thumb");
      var $container = getMainImageContainer();

      if (isVideoThumb) {
        showVideoPreviewInMain($container);
        return;
      }

      clearVideoState($container);

      var findHighlighted = highlightedThumbnail.attr("href");
      var findHighlightedAlt = highlightedThumbnail.find("img").attr("alt");
      $(".p-image a.p-main-image").attr("href", findHighlighted).find("img").attr({ src: findHighlighted, alt: findHighlightedAlt });
    }
  }

  if ($("#rate-form").length) {
    $("#rate-form h3").text(translation("zanechtehodnoceni"));
    $('#rate-form button.btn[data-testid="buttonSendRating"]').text(translation("odeslatrecenzi"));
    $('.add-comment.rate-form-trigger button[data-testid="buttonAddRating"]').text(translation("pridatrecenzi"));
  }
  $(".p-detail-tabs li a").each(function () {
    $(this).removeAttr("role");
    $(this).attr("data-toggle", "scroll");

    if ($(this).text().includes("Podobné")) {
      $(this).text("Související produkty");
    }

    if ($(this).attr("href") === "#ratingTab") {
      const starsHtml = $(".p-detail-info .stars-wrapper > span").html();
      const ratingText = $(".starsLabel--productDetail span").text().trim();
      const ratingCount = parseInt(ratingText, 10);

      function getReviewWord(count) {
        const lastTwo = count % 100;
        const lastOne = count % 10;

        if (lastOne === 1 && lastTwo !== 11) {
          return "Recenze";
        }

        if (lastOne >= 2 && lastOne <= 4 && (lastTwo < 12 || lastTwo > 14)) {
          return "Recenze";
        }

        return "Recenzí";
      }

      if (!isNaN(ratingCount)) {
        $(this).html('<span class="stars star-list">' + starsHtml + "</span>" + getReviewWord(ratingCount) + " (" + ratingCount + ")");
      }

      // 🔧 přepsání <a> na <span>
      $(this)
        .find(".star-list a")
        .each(function () {
          $(this).replaceWith(function () {
            return $("<span>", {
              class: this.className,
              html: $(this).html(),
            });
          });
        });
    }

    if ($(this).text().trim() === "Popis") {
      $(this).text("Popis produktu");
    }

    $(this).closest("li").attr("data-width", $(this).closest("li").outerWidth());
  });

  $(".p-detail-tabs-wrapper #tab-content .tab-pane").removeClass("tab-pane").removeClass("fade").removeClass("active");

  if ($(".basic-description #promeny").length) {
    $('<li class="shp-tab" data-testid="tabRelatedStory"><a data-toggle="scroll" href="#promeny" class="shp-tab-link">Proměny</a></li>').insertAfter('#p-detail-tabs li[data-testid="tabDescription"]');
  }

  if ($(".basic-description #compare").length) {
    $('<li class="shp-tab" data-testid="tabRelatedCompare"><a data-toggle="scroll" href="#compare" class="shp-tab-link">Srovnání</a></li>').insertAfter('#p-detail-tabs li[data-testid="tabDescription"]');
  }
  if ($(".extended-description").length) {
    $('<li class="shp-tab" data-testid="tabRelatedExtendedDescription"><a data-toggle="scroll" href="#extendedDescription" class="shp-tab-link">Pro koho</a></li>').insertBefore('#p-detail-tabs li[data-testid="tabRating"]');
  }

  if ($(".extended-description").length) {
    $('<li class="shp-tab" data-testid="tabDescExtended"><a data-toggle="scroll" href="#extendedDescription" class="shp-tab-link">Parametry</a></li>').insertAfter('#p-detail-tabs li[data-testid="tabDescription"]');

    if ($("#extendedDescription").length) {
      $(".extended-description").appendTo("#extendedDescription");
    } else {
      $('<div id="extendedDescription"></div>').appendTo(".basic-description");
      $(".extended-description").appendTo("#extendedDescription");
    }
  }

  if ($(".basic-description #clanky").length) {
    $('<li class="shp-tab" data-testid="tabRelatedArticles"><a data-toggle="scroll" href="#clanky" class="shp-tab-link">FAQ & články</a></li>').appendTo("#p-detail-tabs");
  }

  if ($("#productsAlternative").length) {
    $('<h2 class="products-related-header">Podobné produkty</h2>').prependTo("#productsAlternative");
  }

  if ($(".products-related").length) {
    $('#p-detail-tabs a[href="#productsAlternative"]').attr("href", "#productsRelated");
    $('<div id="productsRelated"></div>').insertAfter("#description");
    $('<h2 class="products-related-header">' + translation("souvisejici") + "</h2>").prependTo("#productsRelated");
    $(".p-detail > .products-related").appendTo("#productsRelated");
    customProduct();
  }

  $("#tab-content .products-block").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  });

  $('<div class="contact-boxline-wrap"><div class="contact-boxline"><h4>Potřebuješ radu?</h4><div class="contact-wrap"></div></div></div>').appendTo("#tab-content");

  // inicializace
}

if ($(".faq").length) {
  $(".panel-title").on("click", function () {
    let parent = $(this).closest(".panel-item");

    // pokud už je otevřený
    if (parent.hasClass("active")) {
      parent.removeClass("active");
      parent.find(".panel-body").slideUp();
    } else {
      // zavřít ostatní
      $(".panel-item.active").removeClass("active").find(".panel-body").slideUp();

      // otevřít kliknutý
      parent.addClass("active");
      parent.find(".panel-body").slideDown();
    }
  });
}

if ($(".question_box").length) {
  $(".question_box label").on("click", function () {
    let parent = $(this).closest(".question_box");

    // pokud už je otevřený
    if (parent.hasClass("active")) {
      parent.removeClass("active");
      parent.find(".faq_content").slideUp();
    } else {
      // zavřít ostatní
      $(".question_box.active").removeClass("active").find(".faq_content").slideUp();

      // otevřít kliknutý
      parent.addClass("active");
      parent.find(".faq_content").slideDown();
    }
  });
}

function initProductVideoGallery() {
  const $gallery = $(".p-image");
  const $videoBox = $("#productVideos");

  if (!$gallery.length || !$videoBox.length) return;

  // vložení video bloku do galerie
  $gallery.append($videoBox);

  createVideoThumb();
  bindGalleryEvents();
  injectPreviewImage();
  bindColorboxVideoNavigation();
}

function parseYouTubeTimeToSeconds(value) {
  const raw = String(value || "").trim();
  if (!raw) return 0;

  if (/^\d+$/.test(raw)) {
    return parseInt(raw, 10);
  }

  const match = raw.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/i);
  if (!match) return 0;

  const hours = parseInt(match[1] || "0", 10);
  const minutes = parseInt(match[2] || "0", 10);
  const seconds = parseInt(match[3] || "0", 10);

  return hours * 3600 + minutes * 60 + seconds;
}

function toYouTubeEmbedUrl(url) {
  const raw = String(url || "").replace(/&amp;/g, "&").trim();
  if (!raw) return "";

  let parsed;
  try {
    parsed = new URL(raw, window.location.origin);
  } catch (e) {
    return "";
  }

  const host = (parsed.hostname || "").toLowerCase();
  const isYouTubeHost = host.indexOf("youtube.com") !== -1 || host.indexOf("youtu.be") !== -1;
  if (!isYouTubeHost) {
    return "";
  }

  let videoId = "";

  if (host.indexOf("youtu.be") !== -1) {
    videoId = parsed.pathname.replace(/^\//, "").split("/")[0];
  } else if (parsed.pathname.indexOf("/embed/") === 0) {
    videoId = parsed.pathname.split("/embed/")[1].split("/")[0];
  } else {
    videoId = parsed.searchParams.get("v") || "";
  }

  if (!videoId) {
    return "";
  }

  const startRaw = parsed.searchParams.get("start") || parsed.searchParams.get("t") || "";
  const start = parseYouTubeTimeToSeconds(startRaw);
  const embedUrl = new URL("https://www.youtube.com/embed/" + videoId);
  embedUrl.searchParams.set("rel", "0");

  if (start > 0) {
    embedUrl.searchParams.set("start", String(start));
  }

  return embedUrl.toString();
}

function initExtraBanners() {

  const $wrapper = $(".p-image-wrapper").first().length ? $(".p-image-wrapper").first() : $(".p-info-wrapper").first();
  if (!$wrapper.length) {
    return;
  }

  $wrapper.find(".extra-banners").remove();

  const $rows = $(".extended-description tr").filter(function () {
    const text = $(this).find("th").text().replace(/\s+/g, " ").trim();
    return /banner_\d+/i.test(text);
  });
  if (!$rows.length) {
    return;
  }

  const $container = $('<div class="extra-banners"></div>');

  $rows.each(function () {
    const $row = $(this);
    const $tooltip = $row.find(".show-tooltip").first();
    const rawUrl = (
      $tooltip.attr("data-original-title") ||
      $tooltip.attr("data-bs-original-title") ||
      $tooltip.attr("title") ||
      ""
    )
      .replace(/&amp;/g, "&")
      .trim();

    if (!rawUrl) {
      return;
    }

    const valueText = $row.find("td").first().text().trim();
    const value = parseInt(valueText, 10);
    const $item = $('<div class="extra-banner"></div>');

    if (!isNaN(value) && value === 50) {
      $item.addClass("half");
    }

    const embedUrl = toYouTubeEmbedUrl(rawUrl);

    if (embedUrl) {
      $item.append(
        '<div class="extra-banner-video"><iframe loading="lazy" allowfullscreen title="banner video" src="' +
        embedUrl +
        '"></iframe></div>',
      );
    } else {
      $item.append('<img loading="lazy" alt="Banner" src="' + rawUrl + '">');
    }

    $container.append($item);
    $row.remove();
  });

  if ($container.children().length) {
    $wrapper.append($container);
    bindExtraBannerGalleryEvents();
  }
}

function getGalleryThumbs() {
  return $(".p-thumbnails-inner").find("a.p-thumbnail, a.show360image, a.video-preview-thumb");
}

function getMainImageContainer() {
  return $(".p-image");
}

function setHighlightedThumb($thumb) {
  const $thumbs = getGalleryThumbs();
  $thumbs.removeClass("highlighted");
  $thumb.addClass("highlighted");
}

function clearVideoState($container) {
  $container.removeClass("is-video-mode is-video-preview-mode");
  resetProductVideo($container);
}

function openHighlightedVideoInColorbox() {
  const $highlighted = $(".p-thumbnails-inner").find("a.highlighted");

  if (!$highlighted.hasClass("video-preview-thumb")) {
    return false;
  }

  const items = getColorboxGalleryItems();
  if (!items.length) {
    return false;
  }

  const videoIndex = items.findIndex(function (item) {
    return item.type === "video";
  });

  if (videoIndex < 0) {
    return false;
  }

  openColorboxGalleryItem(videoIndex, items);
  return true;
}

function getVideoPreviewImageData() {
  const $thumb = $(".video-preview-thumb").first();
  const $img = $thumb.find("img").first();

  return {
    src: $img.attr("src") || "",
    alt: $img.attr("alt") || "Video preview",
  };
}

function ensureVideoMainPreview($container) {
  if (!$container.length) return $();

  let $preview = $container.find(".video-main-preview");
  if ($preview.length) {
    return $preview;
  }

  $preview = $('<button type="button" class="video-main-preview" aria-label="Play video"></button>');
  $container.append($preview);

  return $preview;
}

function openVideoInMain($container) {
  const $iframe = $container.find("iframe");
  if (!$iframe.length) return;

  $container.removeClass("is-video-preview-mode").addClass("is-video-mode");

  let src = $iframe.attr("src") || "";
  const url = new URL(src, window.location.origin);

  url.searchParams.set("autoplay", "1");

  $iframe.attr("src", url.toString());
}

function showVideoPreviewInMain($container) {
  if (!$container.length) return;

  const imageData = getVideoPreviewImageData();
  if (!imageData.src) {
    openVideoInMain($container);
    return;
  }

  const $preview = ensureVideoMainPreview($container);
  if (!$preview.length) return;

  $preview.html('<img loading="eager" alt="' + imageData.alt + '" src="' + imageData.src + '">');
  $container.removeClass("is-video-mode").addClass("is-video-preview-mode");
  resetProductVideo($container);
}

function resetProductVideo($container) {
  const $iframe = $container.find("iframe");
  if (!$iframe.length) return;

  const base = ($iframe.attr("src") || "").split("?")[0];
  $iframe.attr("src", base + "?rel=0");
}

function createVideoThumb() {
  const $existing = $(".video-preview-thumb");
  if ($existing.length) return;

  const $iframe = $("#productVideos iframe").first();
  if (!$iframe.length) return;

  const $thumb = $('<a class="video-preview-thumb" href="#"></a>');
  const $clone = $('<div class="video-preview-inner"></div>');

  $clone.append($iframe.clone());
  $thumb.append($clone);

  const $thirdThumb = $(".p-thumbnail").eq(1);
  if ($thirdThumb.length) {
    $thirdThumb.before($thumb);
  }
}

function bindGalleryEvents() {
  // výběr videa v náhledech: nejdřív ukázat preview obrázek
  $(document).on("click", ".video-preview-thumb", function (e) {
    e.preventDefault();

    const $thumb = $(this);
    const $container = getMainImageContainer();

    setHighlightedThumb($thumb);

    showVideoPreviewInMain($container);
  });

  // otevření videa v colorboxu po kliknutí na velký preview obrázek
  $(document).on("click", ".video-main-preview", function (e) {
    e.preventDefault();
    openHighlightedVideoInColorbox();
  });

  // návrat na obrázek
  $(document).on("click", ".p-thumbnail, .show360image", function () {
    const $thumb = $(this);
    const $container = getMainImageContainer();

    setHighlightedThumb($thumb);
    clearVideoState($container);
  });
}

function injectPreviewImage() {
  const $row = $(".extended-description tr").filter(function () {
    return $(this).text().indexOf("Video náhled") !== -1;
  });

  if (!$row.length) return;

  const file = $row.find("td").text().trim();
  if (!file) return;

  const imgPath = "/user/documents/upload/Produktová videa - obrázky/" + file;

  const $thumb = $(".video-preview-thumb");
  if ($thumb.length && !$thumb.find("img").length) {
    $("<img>", {
      src: imgPath,
      alt: "Video preview",
    }).prependTo($thumb);
    /*  $("<img>", {
        src: imgPath,
        alt: "Video preview",
      }).prependTo($('#productVideos'));*/
  }

  const $mainContainer = getMainImageContainer();
  const $highlighted = $(".p-thumbnails-inner").find("a.highlighted");
  if ($highlighted.hasClass("video-preview-thumb")) {
    showVideoPreviewInMain($mainContainer);
  }

  $row.remove();
}

function getBaseGalleryItems() {
  const items = [];

  getGalleryThumbs().each(function () {
    const $thumb = $(this);

    if ($thumb.hasClass("video-preview-thumb")) {
      const videoSrc = $("#productVideos iframe").first().attr("src") || $thumb.find("iframe").first().attr("src") || "";

      if (videoSrc) {
        items.push({
          type: "video",
          src: videoSrc,
          alt: "Video",
          origin: "productGallery",
        });
      }

      return;
    }

    const href = $thumb.attr("href");
    if (!href) {
      return;
    }

    items.push({
      type: "image",
      src: href,
      alt: $thumb.find("img").attr("alt") || "",
      origin: "productGallery",
    });
  });

  return items;
}

function getColorboxGalleryItems() {
  return getBaseGalleryItems().concat(getExtraBannerGalleryItems());
}

function getExtraBannerGalleryItems() {
  const items = [];

  $(".extra-banners .extra-banner").each(function () {
    const $banner = $(this);
    const iframeSrc = $banner.find("iframe").first().attr("src") || "";

    if (iframeSrc) {
      items.push({
        type: "video",
        src: iframeSrc,
        alt: "Video",
        origin: "extraBanner",
      });
      return;
    }

    const imageSrc = $banner.find("img").first().attr("src") || "";
    if (!imageSrc) {
      return;
    }

    items.push({
      type: "image",
      src: imageSrc,
      alt: $banner.find("img").first().attr("alt") || "",
      origin: "extraBanner",
    });
  });

  return items;
}

function getColorboxItemsBySource(source) {
  return getColorboxGalleryItems();
}

function bindExtraBannerGalleryEvents() {
  $(document)
    .off("click.extraBannersGallery", ".extra-banners .extra-banner")
    .on("click.extraBannersGallery", ".extra-banners .extra-banner", function (e) {
      e.preventDefault();

      const items = getColorboxGalleryItems();
      if (!items.length) {
        return;
      }

      const bannerIndex = $(".extra-banners .extra-banner").index(this);
      const index = getBaseGalleryItems().length + bannerIndex;

      if (index < 0 || index >= items.length) {
        return;
      }

      openColorboxGalleryItem(index, items);
    });
}

function parseColorboxCurrentIndex(text) {
  const match = String(text || "").match(/(\d+)/);
  return match ? parseInt(match[1], 10) : 0;
}

function normalizeMediaUrl(url) {
  return String(url || "").split("?")[0];
}

function resolveCurrentColorboxIndex(items) {
  const $colorbox = $("#colorbox");
  const storedIndex = $colorbox.data("videoGalleryIndex");

  if (typeof storedIndex === "number" && storedIndex >= 0 && storedIndex < items.length) {
    return storedIndex;
  }

  const $loaded = $("#cboxLoadedContent");
  if ($loaded.find("iframe").length) {
    const iframeSrc = $loaded.find("iframe").first().attr("src") || "";
    const iframeBase = normalizeMediaUrl(iframeSrc);
    const videoIndex = items.findIndex(function (item) {
      return item.type === "video" && normalizeMediaUrl(item.src) === iframeBase;
    });

    if (videoIndex >= 0) {
      return videoIndex;
    }

    return items.findIndex(function (item) {
      return item.type === "video";
    });
  }

  const imageCurrent = parseColorboxCurrentIndex($("#cboxCurrent").text());
  const videoPosition =
    items.findIndex(function (item) {
      return item.type === "video";
    }) + 1;

  if (imageCurrent > 0) {
    const mapped = videoPosition > 0 && imageCurrent >= videoPosition ? imageCurrent : imageCurrent - 1;

    if (mapped >= 0 && mapped < items.length) {
      return mapped;
    }
  }

  const photoSrc = $("#cboxLoadedContent .cboxPhoto").attr("src") || "";
  if (photoSrc) {
    const photoBase = normalizeMediaUrl(photoSrc);
    return items.findIndex(function (item) {
      return item.type === "image" && normalizeMediaUrl(item.src) === photoBase;
    });
  }

  return -1;
}

function updateColorboxCounter(index, items) {
  if (index < 0 || index >= items.length) {
    return;
  }

  const item = items[index];
  const label = item.type === "video" ? "video" : "image";

  $("#cboxCurrent").text(label + " " + (index + 1) + " of " + items.length);
}

function getColorboxVideoMinHeight() {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;

  if (viewportWidth >= 999) {
    return 700;
  }

  return 415;
}

function getColorboxVideoTargetHeight(videoWidth) {
  const minHeight = getColorboxVideoMinHeight();

  if (!videoWidth) {
    return minHeight;
  }

  return Math.max(Math.round(videoWidth * 9 / 16), minHeight);
}

function getInitialColorboxVideoHeight(maxWidth) {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
  const popupWidth = Math.min(Math.round(viewportWidth * 0.9), parseInt(maxWidth, 10) || viewportWidth);
  const sideOffset = viewportWidth >= 768 ? 100 : 20;
  const videoWidth = Math.max(popupWidth - sideOffset, 0);

  return getColorboxVideoTargetHeight(videoWidth);
}

function openColorboxGalleryItem(index, items, source) {
  if (index < 0 || index >= items.length) {
    return;
  }

  const gallerySource = source || "productGallery";
  const popupWidth = "90%";
  const popupHeight = "80%";
  const popupMaxWidth = "1152px";
  const popupMaxHeight = "80%";

  const item = items[index];

  if (item.type === "video") {
    const videoUrl = new URL(item.src, window.location.origin);
    const initialVideoHeight = getInitialColorboxVideoHeight(popupMaxWidth);
    const videoPopupMaxHeight = (window.innerWidth || document.documentElement.clientWidth || 0) >= 999 ? "1200px" : popupMaxHeight;

    videoUrl.searchParams.set("autoplay", "1");

    $.colorbox({
      html: '<div class="cbox-video-wrap" style="margin:0 auto;"><iframe title="video" loading="lazy" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen style="width:100%;height:100%;border:0;display:block;" src="' + videoUrl.toString() + '"></iframe></div>',
      maxWidth: popupMaxWidth,
      maxHeight: videoPopupMaxHeight,
      width: popupWidth,
      height: initialVideoHeight + "px",
      previous: "Předchozí",
      next: "Následující",
      close: "Zavřít",
      onComplete: function () {
        $("#colorbox").data("videoGalleryIndex", index);
        $("#colorbox").data("videoGallerySource", gallerySource);
        updateColorboxCounter(index, items);
        $("#cboxPrevious, #cboxNext").show();
      },
    });

    return;
  }

  if (item.origin === "extraBanner") {
    const imageAlt = String(item.alt || "").replace(/"/g, "&quot;");

    $.colorbox({
      html: '<div class="cbox-image-wrap" style="position:relative;width:100%;max-width:' + popupMaxWidth + ';height:100%;margin:0 auto;"><img alt="' + imageAlt + '" src="' + item.src + '" style="display:block;width:100%;height:100%;max-height:calc(90vh - 320px);object-fit:contain;margin:0 auto;"></div>',
      maxWidth: popupMaxWidth,
      maxHeight: popupMaxHeight,
      width: popupWidth,
      height: popupHeight,
      previous: "Předchozí",
      next: "Následující",
      close: "Zavřít",
      onComplete: function () {
        $("#colorbox").data("videoGalleryIndex", index);
        $("#colorbox").data("videoGallerySource", gallerySource);
        updateColorboxCounter(index, items);
        $("#cboxPrevious, #cboxNext").show();
      },
    });

    return;
  }

  $.colorbox({
    href: item.src,
    photo: true,
    maxWidth: popupMaxWidth,
    maxHeight: popupMaxHeight,
    width: popupWidth,
    height: popupHeight,
    previous: "Předchozí",
    next: "Následující",
    close: "Zavřít",
    onComplete: function () {
      $("#colorbox").data("videoGalleryIndex", index);
      $("#colorbox").data("videoGallerySource", gallerySource);
      updateColorboxCounter(index, items);
      $("#cboxPrevious, #cboxNext").show();
    },
  });
}

function bindColorboxVideoNavigation() {
  $(document)
    .off("cbox_complete.videoGallery")
    .on("cbox_complete.videoGallery", function () {
      if (!$("#colorbox:visible").length) {
        return;
      }

      const source = $("#colorbox").data("videoGallerySource") || "productGallery";
      const items = getColorboxItemsBySource(source);
      if (!items.length) {
        return;
      }

      const currentIndex = resolveCurrentColorboxIndex(items);
      if (currentIndex >= 0) {
        $("#colorbox").data("videoGalleryIndex", currentIndex);
        updateColorboxCounter(currentIndex, items);
      }
    })
    .off("cbox_closed.videoGallery")
    .on("cbox_closed.videoGallery", function () {
      $("#colorbox").removeData("videoGalleryIndex");
      $("#colorbox").removeData("videoGallerySource");
    })
    .off("click.videoGalleryNav", "#cboxNext, #cboxPrevious")
    .on("click.videoGalleryNav", "#cboxNext, #cboxPrevious", function (e) {
      if (!$("#colorbox:visible").length) {
        return;
      }

      const source = $("#colorbox").data("videoGallerySource") || "productGallery";
      const items = getColorboxItemsBySource(source);
      if (!items.length) {
        return;
      }

      const currentIndex = resolveCurrentColorboxIndex(items);
      if (currentIndex < 0) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      const isNext = $(this).is("#cboxNext");
      const targetIndex = isNext ? (currentIndex + 1) % items.length : (currentIndex - 1 + items.length) % items.length;

      openColorboxGalleryItem(targetIndex, items, source);
    });
}

/*
function updateFreeShippingBox() {
     if (!$('.p-info-wrapper .row-free-shipping').length) {
      $('.product-top .p-info-wrapper table.detail-parameters tr:last-of-type').before(`
        <tr class="row-free-shipping">
          <td colspan="2">
            <div id="freeShippingBox">
              <div id="freeShippingText">
                <p class="left"></p>
              </div>
              <div id="freeShippingBar">
                <span class="bar"></span>
              </div>
              <span id="freeShippingAmounts"></span>
            </div>
          </td>
        </tr>
        `
      );
    }
    

    var cartInfo = getShoptetDataLayer('cartInfo');

    if (!cartInfo || !cartInfo.leftToFreeShipping) return;
   
    var freeShippingLimit = freeShipping
    var priceLeft = cartInfo.getNoBillingShippingPrice.withVat; // kolik chybí
    var currentTotal = parseFloat(freeShippingLimit) - parseFloat(priceLeft); // kolik už máš
    var progressPercent = 0;
    priceLeft = Math.abs(parseFloat(priceLeft));
    currentTotal = Math.max(0, currentTotal); // pro jistotu, kdyby vyšlo záporné

    if (cartInfo.cartItems.length === 0) {
      progressPercent = 0;
      priceLeft = freeShippingLimit;
    } else if (priceLeft <= 0) {
      progressPercent = 100;
    } else {
      progressPercent = 100 - (Math.round((currentTotal / freeShippingLimit) * 100));
      if (progressPercent > 100) progressPercent = 100;
    }

    // vytvoření HTML boxu, pokud ještě není

    //console.log(priceLeft)
    //console.log(freeShippingLimit)
    if (priceLeft > freeShippingLimit) {
      var cartItems = getShoptetDataLayer('cart');

      // máš dopravu zdarma a něco v košíku
      $('#freeShippingText .left').text('Máte dopravu zdarma!');
      $('#freeShippingAmounts').html(
        '<strong>' + Number(freeShippingLimit).ShoptetFormatAsCurrency() + '</strong> / ' +
        Number(freeShippingLimit).ShoptetFormatAsCurrency()
      );
      $('#freeShippingBar .bar').css('width', '100%');

    } else {
      $('#freeShippingText .left').html(
        'Nakup už <strong>jen za ' + Number(currentTotal).ShoptetFormatAsCurrency() + '</strong> a získej <strong>dopravu zdarma!</strong>'
      );
      $('#freeShippingAmounts').html(
        Number(freeShippingLimit - currentTotal).ShoptetFormatAsCurrency() + ' / <strong>' +
        Number(freeShippingLimit).ShoptetFormatAsCurrency() + '<strong>'
      );
      $('#freeShippingBar .bar').css('width', progressPercent + '%');
    }
    
  } 
*/

document.addEventListener("ShoptetVariantAvailable", function () {
  $(".variant-list").each(function () {
    var $variant = $(this);
    $variant.find("th .customColor").remove();
    var $checked = $variant.find('input[type="radio"]:checked');
    if ($checked.length && $checked.val() !== "") {
      var text = $checked.closest("label").find(".parameter-value").text().trim();
      if (text.length) {
        $variant.find("th").append('<span class="customColor"><strong>:</strong> ' + text + "</span>");
      }
    }
  });
});

$(".p-detail-rating a.stars-label").on("click", function (e) {
  e.preventDefault();
  $('.tab-navigation a[href="#ratingTab"]').trigger("click");

  var $target = $("#ratingTab");
  if ($target.length) {
    $("html, body").animate(
      {
        scrollTop: $target.offset().top,
      },
      400,
    );
  }
});
